import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer
      role="contentinfo"
      className="mt-24 border-t border-surface-200 dark:border-white/10 bg-white/60 dark:bg-surface-950/60 backdrop-blur-xl"
    >
      <div className="mx-auto max-w-7xl px-6 py-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2 font-display font-bold text-lg">
            <span className="grid place-items-center h-8 w-8 rounded-lg bg-brand-600 text-white">
              <i className="fa-solid fa-cube" aria-hidden="true" />
            </span>
            <span>빌드업</span>
          </div>
          <p className="mt-3 text-sm text-surface-900/70 dark:text-surface-100/70">
            인테리어 운영을 한 곳에서. 공정 / 매출 / 하청 / A/S.
          </p>
        </div>
        <nav aria-label="제품">
          <h4 className="font-semibold mb-3">제품</h4>
          <ul className="space-y-1 text-sm">
            <li><Link to="/features" className="inline-flex items-center min-h-11 -my-1 hover:text-brand-600">기능</Link></li>
            <li><Link to="/pricing" className="inline-flex items-center min-h-11 -my-1 hover:text-brand-600">요금</Link></li>
          </ul>
        </nav>
        <nav aria-label="회사">
          <h4 className="font-semibold mb-3">회사</h4>
          <ul className="space-y-1 text-sm">
            <li><Link to="/company" className="inline-flex items-center min-h-11 -my-1 hover:text-brand-600">회사 소개</Link></li>
            <li><Link to="/help" className="inline-flex items-center min-h-11 -my-1 hover:text-brand-600">도움말</Link></li>
          </ul>
        </nav>
        <nav aria-label="법적 고지">
          <h4 className="font-semibold mb-3">법적 고지</h4>
          <ul className="space-y-1 text-sm">
            <li><Link to="/help" className="inline-flex items-center min-h-11 -my-1 hover:text-brand-600">고객 지원</Link></li>
            <li><Link to="/privacy" className="inline-flex items-center min-h-11 -my-1 hover:text-brand-600">개인정보처리방침</Link></li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-surface-200 dark:border-white/10 py-4 text-center text-xs text-surface-900/60 dark:text-surface-100/60">
        © 2026 BuildUp. All rights reserved.
      </div>
    </footer>
  );
}
